function autoplayProductVideos() {
  const videos = document.querySelectorAll('video');

  videos.forEach((video) => {
    // Only target videos inside Shopify product media/gallery areas
    const productMedia = video.closest(
      'product-media, media-gallery, .product__media, .product-media, .product__media-wrapper, [data-product-media]'
    );

    if (!productMedia) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;

    video.setAttribute('muted', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(() => {});
    }
  });
}

document.addEventListener('DOMContentLoaded', autoplayProductVideos);

document.addEventListener('shopify:section:load', autoplayProductVideos);

const productVideoObserver = new MutationObserver(() => {
  autoplayProductVideos();
});

productVideoObserver.observe(document.body, {
  childList: true,
  subtree: true
});